<template>
  <div class="container mt-20">
    <div class="flex justify-end mb-10">
      <nuxt-link to="/" class="text-yellow-400 underline block">رجوع</nuxt-link>
    </div>
    <h3 class="text-2xl font-bold">الشروط والاحكام</h3>
    <p class="text-sm mt-6">
      يسمح نُدل لأعضائه الذين يستخدمون الخدمة بالطلب من المتاجر عبر موقعها على
      الانترنت. يقدم لك نُدل طريقة سهلة لإيصال طلباتك إلى المتاجر التي يتم عرضها
      على الموقع على الشبكة. إن غرض هذا الموقع هو تقديم خدمة بسيطة ومريحة الى
      العملاء وربطهم بالمتاجر في منطقتهم التي يمكنها تقديم الوجبات ، وتسمح قوائم
      الطعام .التفاعلية للعملاء بإختيار الطلبات والأطباق المفضلة بطريقة سهلة
      وسريعةلقد أنشأنا الموقع ليكون مجمع الكتروني شامل للمطاعم و نُدل عبارة عن
      موقع الكتروني تجاري لإستلام طلبات المتاجر من خلال الإنترنت. ان موقع نُدل
      لا يقوم بالبيع أو التدخل بأي شكل من الأشكال في إنتاج أو تصنيع أو إعداد أي
      طعام يتم انتاجه في المتاجر ، وإن ما يقدمه هذا السوق عبر الإنترنت إلى
      المستخدمين هو فقط توفير إمكانية البحث والعثور على المتاجر المحلية المشتركة
      في الموقع، التي تقوم بتوفير الطعام والطلب من خلاله. وإن هذه المتاجر مسئولة
      بمفردها عن الإلتزام بالقوانين واللوائح والأنظمة والمقاييس والمعايير
      المطبقة في الدولة مثل التي تتعلق بإعداد وتحضير وبيع وتسويق وسلامة الطعام.
      إلا أنه من الأهمية أن يفهم المستخدمين أن نُدل لا يؤكد بأي شكل وعلى نحو
      مستقل على اعتماد والتعهد بمنتجات المتاجر أو مكونات أو نوعية أية منتجات أو
      أن المتجر يلتزم بالقوانين واللوائح المعمول بها لتحضير الطعام حيث أن هذه
      المسئولية تقع على عاتق المتجر بمفرده. يتعين على المشترين الاطلاع على
      المعلومات المقدمة من المتاجر على الموقع وعلى الشبكة أو التي يطلبها
      المشترون مباشرة من المتاجر من حيث نوعية الطعام وموثوقية المتجر، وكذلك
      التزامه بالقوانين واللوائح المعمول بها. ولا يضمن نُدل بأي طريقة كانت نوعية
      أي طعام وجودته، أو أن الأغذية غير متوافقة مع القوانين واللوائح المعمول
      بها، كما لا تضمن مطابقة قائمة الطعام المعروضة على الموقع لما هو يقدم
      فعلياً للمستخدمين. علاوة على ذلك، قد يتعهد المتجر بأن تحضير الطعام يتم
      وفقاً للمقاييس الخاصة مثل معايير "الاورجانيك"، "الماكروبيوتك"، أو معايير
      ذات حساسية خاصة مثل "خالية من المكسرات"، "خالية من الغلوتين" أو"خالية من
      اللاكتوز". ومع ذلك، لا يقوم نُدل على نحو مستقل بالتحقق أو التأكد من هذه
      التعهدات. إن نُدل لن يكون ملزم أو مسؤول عن أي طعام أو خدمات مقدمة من
      المتاجر التي تكون غير صحية، وتتسبب في الاصابة أو تكون غير مقبولة للمشترين،
      أو التي لا تلبي توقعات المشترين بأي طريقة. إن كافة عمليات إعداد الطعام هي
      مسؤولية المتجر الذي يقبل الطلب. مع العلم بأن المتجر سوف يقوم باتخاذ كافة
      الوسائل الممكنة التي يمكنه القيام بها للوفاء بوقت تجهيز الطلب في الوقت
      المحدد، ومع ذلك قد يتأثر وقت التجهيز بعوامل خارج سيطرته ولذلك لا يمكن
      ضمانه. وسوف نبلغكم في حالة علمنا بأي تأخير غير متوقع.عند قيامك باختيار طلب
      من قائمة المطاعم المتوفرة لديك، فأنت تستطيع تقديم طلبك بالضغط على زر
      "تنفيذ الطلب". يرجى الملاحظة أنه من المهم أن تقوم بمراجعة المعلومات التي
      تقوم بإدخالها وتصحيح أي أخطاء قبل الضغط على زر "تنفيذ الطلب" ، نظرا لأنه
      عند الضغط على هذا الإدخال فسوف لا يمكن تصحيح الأخطاء. وعند استلامنا طلبك،
      سوف يبدأ نُدل في تنفيذ الطلب وسوف نرسل رسالة في الصفحة النهائية تُفيد بأنه
      قد تم استلام طلبك وجاري إرساله إلى المتجر و في حالة رفض المتجر للطلب سيتم
      إعلامك و لن نكون ملزمين بتقديم الخدمات. لا يحق للعميل إلغاء الطلب بعد
      قبوله من المتجر. بالرغم من بذل كل جهد لضمان الحفاظ على الأسعار والأوصاف
      الصحيحة، إلا أننا نحتفظ بحق إلغاء أي طلب يحتوي على معلومات غير صحيحة. يجوز
      إلغاء الطلب بعد ذلك بواسطة المتجر بعد استلامك رسالة التأكيد بإرساله إلى
      المتجر. و يحتفظ نُدل والمتاجر المشتركة معها بحق إلغاء أي طلب قبل أو بعد
      القبول، وسوف نقوم بإبلاغك فوراً بأي إلغاء مذكور.خلال استخدام خدمات نُدل،
      يقبل العضو ويقر بما يلي : ان المعلومات الواردة في استمارة التسجيل صحيحة،
      بشرط أن تكون هذه المعلومات مطلوبة، وأن العضو هو المسؤول وحده عن أية خسائر
      قد تنشأ عن أية معلومات خاطئة أو معلومات غير كافية (على سبيل المثال نسيان
      كلمة السر) وفي تلك الحالات يتم انهاء عضويته. إن العضو هو وحده المسؤول عن
      كافة الافكار والاراء والبيانات الشخصية التي يذكرها أثناء استخدامه خدمات
      نُدل، وكذلك مسؤولا عن كافة الملفات التي يتم تحميلها إلى نُدل والمعلومات
      الشخصية المرسلة، وإن نُدل لن يكون مسؤول بأي شكل من الأشكال عن تلك الملفات،
      أو عن الولوج الى أي خدمات مقدمة عبر نُدل يكون غير مصرح بها أو بأي طريقة
      أخرى غير تلك المحددة بواسطة نُدل ، وعدم تغيير البرمجيات بأي طريقة، وتعويض
      نُدل عن كافة الخسائر المادية والأدبية في حالة عدم التزام العضو بالمواد
      المذكورة أعلاه. ولن يكون نُدل مسؤول عن أي أضرار قد تنشأ عن قراءة البيانات
      العائدة الى أي أعضاء بواسطة أي أفراد غير مصرح لهم. ويجب على العضو عدم
      إرسال أي رسائل تكون تهديدية، أو غير أخلاقية، أو عنصرية أو مناقضة للقوانين
      المحلية والاتفاقيات الدولية. وأي مراسلات أو عناوين أو أسماء مستعارة يجب
      ألا تكون مخالفة للوائح و الآداب العامة والسلوك الحسن والقوانين. ويلتزم
      بعدم مضايقة و/أو تهديد المستخدمين الآخرين، أو أي من موظفي خدمة العملاء
      التابعين لنُدل ، وعدم التصرف بطريقة تؤثر على استخدام الخدمات من قبل
      المستخدمين الآخرين، وعدم ارسال، طباعة، أو توزيع أو تعميم أية مواد لا
      أخلاقية، غير مناسبة وغير قانونية أو معلومات قد تسبب ضررا بأسماء أي أشخاص
      أو مؤسسات، أو الإعلان، أو البيع أو العرض لبيع أي منتجات أو خدمات، أو
      المشاركة في أي أفعال ضارة مثل المسح، أو المنافسة أو الرسائل المتسلسلة،
      وعدم إرسال أي معلومات أو برامج قد تؤدي الى الضرر بالمعلومات أو البرمجيات
      على أجهزة المستخدمين الآخرين. وكافة السجلات أو المواد التي يتم الحصول
      عليها بواسطة استخدام خدمات نُدل تكون ضمن موافقة المستخدم، وسوف يكون
      المستخدم مسؤولا تماماً عن أي أضرار أو فقد المعلومات أو أي خسائر أخرى ناتجة
      عن ذلك لجهاز كمبيوتر المستخدم، ولا يحق للمستخدم المطالبة بالتعويض عن أي
      خسائر تنشأ عن استخدام الخدمة، كما يلتزم بعدم استخدام خدمات نُدل لأي أغراض
      تجارية أو إعلانية بدون الحصول على موافقة نُدل. قد يقوم نُدل بمراقبة كافة
      الانظمة في أي وقت أو باستمرار قد يقوم نُدل باستخدام نظامها لأغراض تجارية.
      عدم إرسال أي معلومات بالبريد الإلكتروني تكون محظورة قانونيا أو توزيع أي
      رسائل غير معتمد إرسالها مثل رسائل البريد المتسلسلة والبرامج الضارة الخ،
      وعدم تسجيل وإساءة استخدام أي معلومات شخصية عائدة الى الاخرين. إن العضو
      نفسه مسؤول عن كافة أنواع التصرفات التي يتم القيام بها تحت إسم "المستخدم".
      ويتعين على الأعضاء دفع رسوم الخدمة التي تم طلبها مسبقا عند تسليم المنتجات،
      وخلاف ذلك لن يتم تسليم المنتجات الى العملاء، وعدم الولوج الى الموقع او
      الخدمات باستخدام حساب/تسجيل طرف ثالث بدون موافقة صريحة من حامل الحساب،
      وعدم استخدام الموقع لأغراض غير قانونية، وعدم ارتكاب أي تصرفات مخالفة على
      الموقع أو فيما يخص المحتوى على الموقع، وعدم استخدام الموقع للقيام بأي
      انشطة تجارية غير الاستخدام المصرح له لخدمات نُدل ، وعدم نسخ أي محتوى، بما
      في ذلك وبدون حصر محتوى قوائم المتاجر ومراجعات الغير، لإعادة النشر بشكل
      مطبوع أو عبر الإنترنت، وعدم إنشاء مراجعات المتجر أو تسجيل أي إدخالات لصالح
      أو مع أي غرض تجاري أو غرض آخر أو قصد لا يتفق بنية حسنة مع غرض إنشاء
      الموقع، وعدم محاولة الحصول على حرية دخول غير مصرح بها إلى انظمة كمبيوتر
      الآخرين من أو عن طريق الموقع وعدم التدخل في استخدام شخص آخر أو جهات أخرى
      للموقع ، وعدم تحميل أو نقل الفيروسات أو الملفات الضارة والتخريبية أو
      التدميرية الأخرى، و/أو عدم تعطيل، التدخل في أو حتى التسبب في ضرر أو مخالفة
      أمن الموقع، أو أي خدمات، البرمجيات أو الأجهزة المرتبطة بالنظام، الحسابات،
      كلمات السر، الخوادم أو الشبكات المرتبطة بالموقع أو التي يتم الدخول إليها
      عن طريق المواقع أو المواقع الزميلة أو الموصلة (بما في ذلك تلك العائدة إلى
      شركائنا من المتاجر). يتعين على كافة المستخدمين من القَصر في المكان الذي
      يقيمون فيه (عموما تحت 18 سنة) الحصول على تصريح من ولي أمرهم، ويتم الإشراف
      عليهم مباشرة بواسطة ولي امرهم أو الاب / الام عند استخدام الموقع. إذا كنت
      قاصر، يتعين على ولي أمرك/ والدك قراءة هذه الاتفاقية و الاطلاع عليها قبل
      قيامك باستخدام الموقع على الشبكة. بخلاف المعلومات الشخصية، التي تم تغطيتها
      في سياسة الخصوصية لشركة نُدل ، فإن أي مواد تقوم بإرسالها أو نشرها على هذا
      الموقع على الشبكة سوف تعتبر غير سرية وغير شخصية. ولن يكون على نُدل أي
      التزامات فيما يخص هذه المواد. وسوف يكون لنُدل واي شخص نقوم بتعيينه الحرية
      لنسخ وتصحيح وتوزيع وتضمين أو أي استخدام خلاف ذلك لهذه المواد وكافة
      البيانات والصور والأصوات والنصوص والاشياء الاخرى المشمولة فيه لأي ولكافة
      الأغراض التجارية وغير التجارية. يحظر عليك نشر وتحميل أو ارسال إلى أو من
      الموقع على الشبكة أي من المواد التالية: تنتهك أي قانون محلي، وطني أو دولي
      معمول به. غير مشروعة أو احتيالية تصل الى حد الاعلان غير المصرح به أو تحتوي
      على فيروسات أو أي برامج اخرى ضارة. لا يجوز لك إساءة استخدام الموقع (بما في
      ذلك بواسطة القرصنة) أي تعليقات أو ملاحظات يضعها المستخدم على الموقع يجب
      ألا: تحتوي على أي مواد تشهيرية، خليعة أو مخالفة. تعزز العنف أو التمييز
      تنتهك حقوق الملكية الفكرية لشخص آخر. تنتهك أي واجب قانوني تجاه طرف ثالث
      (مثل واجب السرية) تعزز النشاط غير القانوني أو تخترق خصوصية الآخر تقدم
      انطباعا أنها صادرة عنها أو يتم استخدامها لتقمص شخصية شخص آخر أو تقديم
      معلومات خاطئة عن ارتباطك بشخص آخر إن التصرفات المحظورة الواردة في الفقرات
      اعلاه غير حصرية. وسوف يقوم بتعويض نُدل عن كافة النفقات والأضرار التي
      تتحملها كنتيجة لانتهاكك لأي من تلك القيود. سوف يقوم نُدل بالتعاون بالكامل
      مع أي جهات تنفذ القانون أو قرارات المحكمة التي تطلب منا أو توجهنا للتصريح
      عن هوية أو موقع أي شخص يقوم بنشر أي مواد بمخالفة الفقرات المذكورة أعلاه .
      يجوز أن يقوم نُدل بشكل مؤقت بتوقيف أو التوقف تماما عن تشغيل النظام في أي
      وقت. لن يكون على نُدل أية مسؤوليات تجاه أعضاء نُدل أو أي طرف ثالث بسبب
      التوقيف المؤقت أو التوقف الكامل لتشغيل النظام. سوف يتم عرض اسم المستخدم
      وكلمة السر واعتماده بعد تعبئة بيانات النموذج الذي سيتم تقديمه إلى العملاء
      بواسطة نُدل . ويجوز أن يقوم نُدل بمنع عملائها الذين قاموا بتعبئة بيانات
      النموذج أو تواصلوا مع الموقع، بالرغم من أن لديهم كلمات سر من الحصول على
      كلمة سر جديدة أو من استخدام كلمات السر الخاصة بهم لمدة زمنية غير محددة؛ إذ
      اعتبر نُدل ذلك ضروري. لا يضمن نُدل أن خدماته سوف يتم تقديمها في الوقت
      المحدد بطريقة آمنة وتامة، وإن النتائج التي سيتم الحصول عليها من الخدمات
      سوف تكون صحيحة وموثوق فيها، وأن نوعية الخدمات سوف ترقى إلى مستوى التوقعات،
      حيث أن دور نُدل ينحصر في إخطار المتجر بطلبات العميل. يحق لنُدل أن تقوم
      بدعم وحذف كافة أو بعض الملفات والرسائل التي يتم تقديمها بواسطة الأعضاء
      أثناء استخدام الخدمات لبعض الوقت وذلك خلال الفترات التي تعتبر مناسبة
      بواسطة نُدل . ولن يكون نُدل مسؤول عن إجراءات الدعم والحذف. إن نُدل لديه
      حقوق الملكية والنشر الناشئة عن ملكية المعلومات والمستندات والبرمجيات
      والتصميمات والرسوم البيانية الخ، التي تقوم بانتاجها بنفسها و/أو يتم شراؤها
      من الخارج. و نُدل ليس مسؤول عن أي وجبة يتم طلبها ولم يتم تقديمها من قبل
      المتجر بسبب عدم توفرها يحق لنُدل نشر أي معلومات ومستندات وبرمجيات وتصميمات
      ورسوم بيانية الخ (مثل الرسائل والاشعار والتقارير/الأخبار والملفات المرسلة
      إلى النشرات) التي يتم إنتاجها بواسطة الأعضاء وتحميلها إلى النظام بواسطة
      الأعضاء و/أو يتم إرسالها إلى مكان آخر ضمن الموقع يعتبر ملائم بواسطة نُدل
      ومن المحتمل أن يتم نسخ و/أو نشر هذه المعلومات بواسطة المستخدمين الآخرين.
      وفي تلك الأحوال، لن يطلب المستخدمين أي أتعاب من نُدل. إن الالتزام بتغيير
      المعلومات المتعلقة بالسعر ومواصفات المنتج التي يتم تقديمها للبيع عبر نُدل
      يعود إلى الشركات التي يكون لديها مطاعم مشتركة مع نُدل. وفي حالة أية
      معلومات خاطئة تتعلق بالسعر ومواصفات المنتج، يجوز أن يقوم نُدل بتصحيح الخطأ
      عن طريق الغاء الطلب. يجوز أن يقوم نُدل بإرسال العضو إلى موقع آخر على
      الشبكة. وفي هذه الحالة، يوافق العضو على أن نُدل لن يكون مسؤول عن سياق
      محتوى الموقع الذي يجوز للعضو الولوج إليه. يجوز أن يقوم نُدل بأي تغييرات
      على تنفيذ هذه الاتفاقية وتعديل المواد القائمة أو اضافة مواد جديدة لغرض
      الالتزام بأي التزامات فنية وتشريعات يتم إصدارها في المستقبل. يجوز أن يقوم
      نُدل بتغيير الخدمات التي لا تتطلب عضوية إلى شكل يتطلب عضوية. ويجوز أن يقوم
      نُدل بتقديم خدمات اضافية وتغيير بعض الخدمات جزئيا أو بالكامل أو تحويلها
      إلى خدمة مدفوعة. يجوز أن يكون هذا الموقع غير متاح في بعض الأوقات للسماح
      بعمليات الصيانة والتحديث. وبالرغم من أننا سوف نسعى لابلاغ العملاء مسبقا
      بعدم توفر أي خدمة مذكورة، إلا أن ذلك لا يمكن ضمانه و نحتفظ بحق تعديل أو
      سحب الخدمة في أي وقت.تتم الموافقة على التعليقات المرسلة من المستخدمين وفق
      المعايير التالية: العلاقة المباشرة: يجب أن يكون الشخص صاحب التعليق قد
      اختبر الخدمة مباشرة من خلال المتجر. المحتوى المقبول للتعليق: نُدل غير ملزم
      بقبول أي من التعليقات التي يتم إرسالها عن طريق المستخدمين، ومن بعض الأسباب
      التي يمكن أن نرفض نشر التعليقات بسببها هي كالآتي: التعليقات التي تحتوي على
      لهجة هجومية، إباحية ، إساءة ، عنصرية ، لغة الكراهية ، كلها أمـور لا يمكننا
      نشرها على موقعنا. تعليقات ليس لها علاقة بموضوع تقييم المتجر. التعليقات
      التي تتضمن التمييز القائم على الـدين، العـرق، الجنس، العمر، الحالة الزوجية
      أو الإعاقة الجسدية أو الفكرية. أي محتوى له دلالات أو إشارات تخالف تقاليد
      المجتمع، أو تدعو الى توجه غير قانوني. تضارب المصالح : حيث لا يُسـمح
      للمطاعم المنافسة وضع أي تعليقات سلبية. (أي مخالفات بهذا الصدد، يمكن أن
      تؤدي إلى إزالة دائمة لتلك المتاجر من موقعنا). الادعاءات المتعلقة بمخالفة
      قوانين الصحة. التعليقات التي تعكس معلومات قديمة وغير نافذة. أصحاب
      التعليقات لا يمثلون رأي موقع نُدل على الإطلاق ولا الشركة المالكة الرئيسية،
      ولا أي من الشركات التابعة. موقع نُدل غير مسؤول عن أي التزامات أو مطالبات
      أو خسائر ناتجة عن أي من التعليقات المنشورة أو أي من المحتوى الموجود على
      الموقع. ملكية نُدل: التعليقات المنشورة على الموقع هي ملك لموقع نُدل
      وملكيتها حصرية إلى الأبد. لدينا الحق في إعادة إنتاج وتعديل وترجمة ونقل
      و/أو توزيع جميع المواد المتعلقة بالتعليقات. نُدل ليس ملزم بأي شكل من
      الأشكال بالدفع لأصحاب التعليقات أو لأي شخص أو جهة أخــرى مقابل
      تعليقاتهم.عند قبول طلبك، فإن ذلك يمثل اتفاق بينك كعميل وبين المتجر، وتقع
      على المتجر وحده المسؤولية عن هذا الطلب. ويتم الدفع النقدي مباشرةً إلى
      المتجر الذي يقوم بتلبية الطلب. وفي حالة اختيارك للدفع عن طريق بطاقة ائتمان
      أو الدفع المسبق عبر الموقع، عندئذ سيتم تنفيذ المعاملة من خلال نُدل كوسيط
      بينك وبين المتجر. يحق للعميل إلغاء الطلب في حال تجاوز ساعة من زمن التقديم
      المحدد من قبل المتجر ، وسوف يتم رد المبلغ الذي قام العميل بدفعه إلى حساب
      العميل. لا يحق للعميل إلغاء الطلب بعد قبوله من المتجر. قد تستغرق عملية
      استرداد المبلغ لحساب العميل عبر بوابة الدفع الخاصة ببطاقة الدفع المسبق /
      الائتمان مدة يومين عمل، وفي حال أي تأخير في إعادة قيد المبلغ لحساب العميل
      الذي قام بدفعه، يتوجب على العميل المتابعة مع البنك مباشرة وسوف نرسل رسالة
      إلكترونية للعميل تحتوي على نسخة مطبوعة من إشعار رد المبلغ المطبوع وذلك من
      بوابة الدفع الخاصة ببطاقة الدفع المسبق / الائتمان كمرجع له في حالة ما إذا
      رغب العميل في مراجعة البنك . إن العملاء المستخدمين لخدمة الدفع الخاصة
      ببطاقة الدفع المسبق / الائتمان مطالبين بالتواجد على أرقام الاتصال الخاصة
      بهم. سوف يتم تعويض العميل من قبل المتجر في حالة نقص أو خطأ أي جزء من الطلب
      (يسري التسديد فقط مقابل البند الناقص و الخاطئ ويخضع التعويض للسياسة الخاصة
      بـنُدل) ان العميل مسؤول بالكامل عن تنفيذ وتقديم الطلب باستخدام خدمة الدفع
      الخاصة ببطاقة الدفع المسبق / الائتمان بعد القراءة الدقيقة لكافة الشروط
      والاحكام.
    </p>
    <h3 class="text-lg font-semibold"></h3>
    <p class="text-sm"></p>
  </div>
</template>
